"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Image_1 = require("./Image");
exports.default = Image_1.default;
//# sourceMappingURL=index.js.map